import React, { useEffect, useRef } from "react";
import { FaCheckCircle, FaSmile, FaRocket, FaAward } from "react-icons/fa";
import CountUp from "react-countup";
import { Fade } from "react-awesome-reveal";
import autoAnimate from "@formkit/auto-animate";

const StatsShowcase = () => {
  const parent = useRef(null);

  useEffect(() => {
    parent.current && autoAnimate(parent.current);
  }, []);

  const stats = [
    { icon: <FaCheckCircle />, count: 38, label: "Projects Completed" },
    { icon: <FaSmile />, count: 35, label: "Happy Clients" },
    { icon: <FaRocket />, count: 3, label: "Ongoing Projects" },
    { icon: <FaAward />, count: 4, label: "Years of Experience" }
  ];

  return (
    <section className="relative py-24 px-6 md:px-16 bg-gradient-to-b from-white via-gray-50  to-gray-300 text-gray-900">
      {/* Soft background gradient blobs */}
      <div className="absolute inset-0 overflow-hidden -z-10">
        <div className="absolute top-[-100px] left-[-100px] w-[300px] h-[300px] bg-purple-300 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-pulse" />
        <div className="absolute bottom-[-100px] right-[-100px] w-[300px] h-[300px] bg-indigo-400 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-pulse" />
      </div>

      <div className="max-w-6xl mx-auto text-center">
        <Fade triggerOnce>
          <h2 className="text-4xl md:text-5xl font-extrabold tracking-tight text-gray-800 mb-6">
            Our <span className="text-indigo-500">Impact</span> in Numbers
          </h2>
        </Fade>

        <Fade triggerOnce delay={100}>
          <p className="text-lg text-gray-600 mb-16 max-w-xl mx-auto">
            Proven performance backed by real results and client trust.
          </p>
        </Fade>

        <div
          ref={parent}
          className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-10"
        >
          {stats.map((stat, i) => (
            <Fade triggerOnce direction="up" delay={i * 100} key={i}>
              <div className="bg-white backdrop-blur-md  shadow-xl rounded-2xl p-8 flex flex-col items-center transition-all hover:scale-105 hover:shadow-2xl duration-300">
                <div className="text-4xl text-indigo-500 mb-4">{stat.icon}</div>
                <h3 className="text-4xl font-bold text-gray-900 ">
                  <CountUp end={stat.count} duration={2} />
                </h3>
                <p className="text-sm font-semibold text-gray-700  mt-2 uppercase tracking-wide">
                  {stat.label}
                </p>
              </div>
            </Fade>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsShowcase;
